import { createSelector } from 'reselect';

import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';

const getEmbeddedLaborTicketFlowEnabled = createSelector(
  [getLaunchDarklyFlags],
  (flags) => {
    return flags?.[FLAG_KEYS.EMBEDDED_LABOR_TICKET_FLOW_ENABLED];
  }
);

export { getEmbeddedLaborTicketFlowEnabled };
